import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

const GetStartedPackage = ({ children, recommended }) => {
  return (
    <div className="responsive-w mw440 mb5 mb0-l">
      <div
        className={classNames({
          'bg-white br2 shadow-1 pv5 ph4 pv6-m ph5-m h-100': true,
          'flex flex-column relative': true,
          'z-3 scale-03 gold-border': recommended
        })}
      >
        {children}
      </div>
    </div>
  )
}

GetStartedPackage.propTypes = {
  children: PropTypes.node,
  recommended: PropTypes.bool
}

export default GetStartedPackage



// WEBPACK FOOTER //
// ./src/components/get-started-package/get-started-package-layout.js